// extracted by mini-css-extract-plugin
module.exports = {"topics":"styles-module__topics___Q_SYC","topic":"styles-module__topic___3EajD"};